export const config = {
	maxFileSize: 1000 * 1000 * 1000 * 10 // 10GB
};
